import { createSlice } from '@reduxjs/toolkit'
import { strapiFetch, StrapiApiError } from '../../api/strapi'
import { adaptSearchResults } from '../../api/searchAdapter'

const slice = createSlice({
    name: 'search',
    initialState: {
        data: null,
        searchResults: null,
        loading: false,
        loaded: false,
        error: null,
    },
    reducers: {
        setLoading: (state, action) => { state.loading = action.payload },
        setLoaded: (state, action) => { state.loaded = action.payload },
        setData: (state, action) => { state.data = action.payload },
        setSearchResults: (state, action) => { state.searchResults = action.payload },
        setError: (state, action) => { state.error = action.payload },
    },
})

export default slice.reducer

export const { setLoading, setLoaded, setData, setSearchResults, setError } = slice.actions

export const fetchSearchResults = (keyword, locale, page = 1) => async dispatch => {
    dispatch(setLoading(true))
    dispatch(setError(null))
    try {
        const json = await strapiFetch('/api/search', { locale, params: { keyword, page } })
        dispatch(setData(json))
        dispatch(setSearchResults(adaptSearchResults(json, locale)))
        dispatch(setLoaded(true))
        return json
    } catch (e) {
        dispatch(setError(e instanceof StrapiApiError ? e.message : 'Search failed'))
        return null
    } finally {
        dispatch(setLoading(false))
    }
}

// Old Search/index.js contract: dispatch(searchToServer(keyword))
export const searchToServer = (keyword) => async (dispatch, getState) => {
    const locale = (typeof window !== 'undefined' && window.location.pathname.split('/')[1]) || 'en'
    dispatch(setSearchResults(null))
    return dispatch(fetchSearchResults(keyword, locale === 'id' ? 'id' : 'en'))
}
